import ReactDOM from 'react-dom/client'
import App from './App.jsx'

const API_BASE = import.meta.env.VITE_API_BASE || '/api';

// PRELOAD projects and trigger re-render
window.__GLING_PROJECTS__ = [];
window.__GLING_UPDATE__ = null;

fetch(`${API_BASE}/projects.php`)
  .then(async (r) => {
    const text = await r.text();
    if (!r.ok) {
      console.warn('PRELOAD projects.php HTTP', r.status, text.slice(0, 300));
      return null;
    }
    try {
      return text ? JSON.parse(text) : null;
    } catch (e) {
      console.warn('PRELOAD projects.php invalid JSON', text.slice(0, 200));
      return null;
    }
  })
  .then((d) => {
    if (!d) return;
    console.log('✅ PRE-LOADED PROJECTS:', d.total);
    window.__GLING_PROJECTS__ = d.projects || [];
    if (window.__GLING_UPDATE__) {
      window.__GLING_UPDATE__(d.projects || []);
    }
  })
  .catch((e) => console.warn('PRELOAD projects failed', e));

ReactDOM.createRoot(document.getElementById('root')).render(<App/>)
